import apiClient from "./apiClient";

export const fetchUsefulInfos = async () => {
    const response = await apiClient.get("/api/useful_information/all");
    return response.data;
};

export const createUsefulInfo = async (data) => {
    const response = await apiClient.post("/api/useful_information", data);
    return response.data;
};

export const updateUsefulInfo = async (id, data) => {
    const response = await apiClient.put(`/api/useful_information/${id}`, data);
    return response.data;
};

export const deleteUsefulInfo = async (id) => {
    await apiClient.delete(`/api/useful_information/${id}`);
};